import { render, staticRenderFns } from "./DexPWABanner.vue?vue&type=template&id=05354aba&scoped=true&"
import script from "./DexPWABanner.vue?vue&type=script&lang=ts&"
export * from "./DexPWABanner.vue?vue&type=script&lang=ts&"
import style0 from "./DexPWABanner.vue?vue&type=style&index=0&id=05354aba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05354aba",
  null
  
)

export default component.exports